function _jade_template_fn(locals) {
  locals = locals || {};;;
  var result_of_with = (function($attr, $component, $helpers, Object) {
    var h = require("panel").h;
    const iconOnly = !$component.textContent.trim() && !!$attr(`icon`);;
    const classes = $helpers.getComponentClasses(`mp-button-`);;
    const isPrimary = $attr(`color`) === 'blue' || classes['mp-button-primary'];;
    const isSecondary = $attr(`color`) === 'grey' || classes['mp-button-secondary'];;
    const isRed = $attr(`color`) === 'red' || classes['mp-button-red'];;
    const noTheme = !!$attr(`theme`);;
    return {
      value: (h("div", {
        "attrs": $helpers.getButtonAttrs(),
        "class": Object.assign({}, Object.assign(classes, {
          'mp-button-with-icon': !!$attr(`icon`),
          'mp-button-icon-only': iconOnly,
          'mp-button-primary': !noTheme && isPrimary,
          'mp-button-secondary': !noTheme && isSecondary,
          'mp-button-red': !noTheme && isRed,
          'mp-button-small': $attr(`size`) === 'small',
          'mp-button-large': $attr(`size`) !== 'small',
          'mp-button-new-primary': $attr(`theme`) === `primary`,
          'mp-button-new-secondary': $attr(`theme`) === `secondary`,
          'mp-button-tertiary': $attr(`theme`) === `tertiary`,
          'mp-button-subtle': $attr(`theme`) === `subtle`,
        }), {
          'mp-button-container': true
        }),
      }, (function() {
        var __jade_nodes = [];
        __jade_nodes = __jade_nodes.concat(h("div", {
          "class": {
            'mp-button-content': true
          },
        }, (function() {
          var __jade_nodes = [];
          __jade_nodes = __jade_nodes.concat(($attr(`icon`)) ? ((function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat(h("svg-icon", {
              "attrs": {
                icon: $attr(`icon`)
              },
            }));;
            return __jade_nodes
          }).call(this)) : undefined);
          __jade_nodes = __jade_nodes.concat((!(iconOnly)) ? ((function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat(h("slot"));;
            return __jade_nodes
          }).call(this)) : undefined);;
          return __jade_nodes
        }).call(this).filter(Boolean)));;
        return __jade_nodes
      }).call(this).filter(Boolean)))
    };
  }.call(this, "$attr" in locals ? locals.$attr : typeof $attr !== "undefined" ? $attr : undefined, "$component" in locals ? locals.$component : typeof $component !== "undefined" ? $component : undefined, "$helpers" in locals ? locals.$helpers : typeof $helpers !== "undefined" ? $helpers : undefined, "Object" in locals ? locals.Object : typeof Object !== "undefined" ? Object : undefined));
  if (result_of_with) return result_of_with.value;
}
module.exports = _jade_template_fn;